import { createApiHook, useApi } from "../utils/apiUtils";

const useDeleteQuestion = () => {
  const { apiDelete } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const deleteQuestion = async (id) => {
    startLoading();
    const res = await apiDelete(`/questions/${id}`, "Error al eliminar la pregunta");

    setResponse(res);

    if (res?.error) {
      const err = new Error(res.error.message || "No se pudo eliminar la pregunta");
      err.backend = res.error;
      throw err;
    }

    return res;
  };

  return { deleteQuestion, data, loading, error };
};

export default useDeleteQuestion;
